// Project Imports
import Product from 'constants/ProductConstants';

const fetchPremiumBreakBenefit = (solutionData) => {
    let premiumBreakList = []

    solutionData.coverage.forEach((coverage) => {
        coverage.life_assured_list.forEach(lifeAssured => {
            lifeAssured.product_details.forEach(obj => {
                let premiumBreak = fetchInputStringOpt('@PR_OPTION_9', obj.data.InputString) === "22"
                let benefitMessage = ""
                switch (obj.product_name) {
                    case Product.ZINDAGI_PROTECT:   
                    if (premiumBreak) {
                        let noOfpremiumBreaks = obj.data.OutputJSON[0][0].NUM_PREMIUM_BREAK
                            benefitMessage =`Skip ${Number(noOfpremiumBreaks)} premiums during the premium paying term without compromising on any of the policy benefits`
                            if (!checkBenefitAvailable(benefitMessage, premiumBreakList))
                                premiumBreakList.push(benefitMessage)
                        }
                        break;
                }
            })
        })
    })
    return premiumBreakList
}

const fetchInputStringOpt = (key, inputString) => {
    return inputString.filter((item) => item.Key == key)[0]?.Value || 'NO'
}

const checkBenefitAvailable = (benefit, coverList) => {
    return coverList.some((item) => item === benefit)
}

export default fetchPremiumBreakBenefit